import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/cleopatraenterprise.webp';
import screenshot_target from '../../../images/letterfunnel/christiaandesbouvrie.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Christiaan des Bouvrie"
      firstname="Christiaan"
      companyname="Cleopatra Enterprise"
      competition="InEight en Contruent"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/christiaandesbouvrie.js